import { useQuery } from "@tanstack/vue-query";
import { type IncludeArr, User, type UserEntity } from "~/src/api";

export const useUsername = (
  username: MaybeRefOrGetter<string>,
  includes: IncludeArr<UserEntity>,
  auth?: AuthFunction,
) => {
  return useQuery({
    queryKey: ["user", "entity", "username", username, { authed: !!auth }],
    queryFn: async () => {
      const id = await User.getByUsername(toValue(username));
      return await User.get(id, includes, (await auth?.()) || undefined);
    },
  });
};
